module.exports = __webpack_public_path__ + "static/media/bowen-31.c37dfd07.jpg";